import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Breadcrumbs, Typography, Link } from '@material-ui/core';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
import MUIDataTable from 'mui-datatables';
import useStyles from '../../styles';
import EditTwoFieldsDialog from '../Dialogs/EditTwoFieldsDialog';
import FullsizeTableOptions from '../Elements/FullsizeTableOptions';
import AddSlaDialog from '../Dialogs/AddSlaDialog';
import DeleteDialog from '../Dialogs/DeleteDialog';
import LocalNumberFormat from '../Elements/LocalNumberFormat';

function DatabasePiecePricesTable(props) {
  const {
    piecePrices,
    projects,
    addPiecePrice,
    updatePiecePrice,
    deletePiecePrice,
    selectProject,
    selectedProject,
    selectTemplate,
    selectPiecePrice,
    priceType,
    // templates,
  } = props;

  const classes = useStyles();
  const columns = [
    {
      name: '_id',
      label: 'ID',
      options: {
        display: false,
        viewColumns: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: 'templateName',
      label: 'Dokument',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'moduleName',
      label: 'Modul',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'unit',
      label: 'Einheit',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'amount',
      label: 'Menge',
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ({ className: classes.rightAlignedHeader }),
        setCellProps: () => ({ className: classes.rightAlignedCell }),
        customBodyRender: (value) => <LocalNumberFormat value={value} />,
      },
    },
    {
      name: 'pricePerPiece',
      label: 'Stückpreis in €',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'calculation',
      label: 'Verrechnung',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'annualCost',
      label: 'Kosten in € p.a.',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'options',
      label: 'Optionen',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => (
          <div>
            <EditTwoFieldsDialog
              priceId={tableMeta.rowData[0]}
              projectId={selectedProject}
              oldData={[tableMeta.rowData[3], tableMeta.rowData[4].toString()]}
              header="Stückpreis bearbeiten"
              onClick={updatePiecePrice}
              fields={{ fieldOne: 'Einheit', fieldTwo: 'Menge' }}
            />
            <DeleteDialog
              header="Stückpreis löschen"
              text="Möchten Sie den Stückpreis wirklich löschen?"
              onClick={() => deletePiecePrice({
                variables: { projectId: selectedProject, moduleId: tableMeta.rowData[10], priceId: tableMeta.rowData[0] },
              })}
            />
          </div>
        ),
      },
    },
    {
      name: 'template',
      label: 'TemplateId',
      options: {
        display: false,
        viewColumns: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: 'moduleId',
      label: 'ModuleId',
      options: {
        display: false,
        viewColumns: false,
        filter: false,
        sort: false,
      },
    },
  ];

  const data = [];

  piecePrices.forEach((piecePrice) => {
    data.push({
      _id: piecePrice._id,
      moduleName: piecePrice.moduleName,
      unit: piecePrice.unit,
      amount: piecePrice.amount,
      pricePerPiece: 'Wird vom Anbieter ausgefüllt.',
      calculation: piecePrice.calculation,
      annualCost: 'Wird automatisch berechnet.',
      template: piecePrice.template,
      templateName: piecePrice.templateName,
      moduleId: piecePrice.moduleId,
    });
  });
  return (
    <div>
      <MUIDataTable
        title={
          <div style={{ display: 'flex' }}>
            <Button size="small" onClick={() => selectPiecePrice('')}>
              <KeyboardReturnIcon fontSize="small" />
            </Button>
            <Breadcrumbs>
              <Link
                color="inherit"
                component={RouterLink}
                to="/database"
                onClick={() => {
                  selectProject('');
                  selectTemplate('');
                  selectPiecePrice('');
                }}
              >
                Übersicht
              </Link>
              <Link
                color="inherit"
                component={RouterLink}
                to="/database"
                onClick={() => selectPiecePrice('')}
              >
                {projects.name}
              </Link>
              <Typography color="textPrimary">Stückpreise</Typography>
            </Breadcrumbs>
          </div>
        }
        data={data}
        columns={columns}
        options={FullsizeTableOptions({
          sortOrder: { name: 'templateName', direction: 'asc' },
        })}
      />
      <AddSlaDialog
        projectId={selectedProject}
        header="Stückpreis für Modul hinzufügen"
        slas={piecePrices}
        type={priceType}
        // templates={templates}
        onClick={addPiecePrice}
      />
    </div>
  );
}

export default DatabasePiecePricesTable;

DatabasePiecePricesTable.propTypes = {
  projects: PropTypes.shape(Object).isRequired,
  // templates: PropTypes.arrayOf(PropTypes.shape(Object)).isRequired,
  piecePrices: PropTypes.arrayOf(PropTypes.shape(Object)).isRequired,
  selectedProject: PropTypes.string.isRequired,
  priceType: PropTypes.string.isRequired,
  addPiecePrice: PropTypes.func.isRequired,
  updatePiecePrice: PropTypes.func.isRequired,
  deletePiecePrice: PropTypes.func.isRequired,
  selectProject: PropTypes.func.isRequired,
  selectTemplate: PropTypes.func.isRequired,
  selectPiecePrice: PropTypes.func.isRequired,
};
